// src/context/RealizacjeContext.js
import { createContext, useContext, useState, useEffect } from "react";

const RealizacjeContext = createContext();

export const useRealizacje = () => useContext(RealizacjeContext);

export const RealizacjeProvider = ({ children }) => {
  const [realizacje, setRealizacje] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await fetch("/Realizacje.json");
        const data = await res.json();
        setRealizacje(data);
      } catch (err) {
        console.error("Błąd ładowania realizacji:", err);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  return (
    <RealizacjeContext.Provider value={{ realizacje, loading }}>
      {children}
    </RealizacjeContext.Provider>
  );
};
